export default "__VITE_ASSET__BANmRJ1H__"